module.exports = __webpack_public_path__ + "img/miami.82fdc8b8.jpg";